import './Chart.css';
import React, { useCallback, useState } from 'react';
import { PieChart, Pie, Cell, Tooltip, Legend } from 'recharts';

export const Chart = ({ data }) => {
  return (
    <div name="Chart">
       <PieChart width={400} height={300}>
     <Pie
       data={data}
       cx={200}
       cy={150}
       outerRadius={85}
     >
      {data.map((entry, index) => (
      <Cell key={`cell-${index}`} fill={entry.color} label></Cell>
         ))}</Pie>
     <Legend align='center' iconSize={10} ></Legend>
     <Tooltip></Tooltip>
    </PieChart>
    </div>
  );
};
